import dynamic from 'next/dynamic';
import type { CalendarProps } from './calendar-base';
export type { CalendarProps };

// react-day-picker 와 그 CSS 는 달력을 실제로 열 때만 받는다. `@/ui` 배럴을 쓰는 모든
// 화면 번들에 딸려 들어가지 않게 하려는 것. Pages Router 라 'use client' 로는 나뉘지 않는다.
export const Calendar = dynamic<CalendarProps>(() => import('./calendar-base').then(mod => mod.Calendar), {
  ssr: false,
  loading: () => null
});